// =======================================================
// ENTRY POINT - Accessibility Widget
// Caricato in modo indipendente dal bundle principale,
// con attributo defer nel tag <script> del layout.
// Viene eseguito dopo il parsing del DOM, prima di DOMContentLoaded.
// =======================================================

import { initAccessibilityWidget } from '~/components/AccessibilityWidget';

document.addEventListener('DOMContentLoaded', initAccessibilityWidget);
